import React, { useState, useEffect } from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { checkAuth } from '../utils/api';

const ProtectedRoute = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const verifyAuth = async () => {
      try {
        // #region agent log
        fetch('http://127.0.0.1:7243/ingest/c774ac2f-3ff0-4054-a0b4-90f182dc7495',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'ProtectedRoute.js:verifyAuth-start',message:'Starting auth verification',data:{pathname:location.pathname,hasToken:!!localStorage.getItem('token'),tokenLength:localStorage.getItem('token')?.length},timestamp:Date.now(),sessionId:'debug-session',runId:'session-debug',hypothesisId:'S1'})}).catch(()=>{});
        // #endregion agent log
        
        // First check if we have a token
        const token = localStorage.getItem('token');
        if (!token) {
          // #region agent log
          fetch('http://127.0.0.1:7243/ingest/c774ac2f-3ff0-4054-a0b4-90f182dc7495',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'ProtectedRoute.js:verifyAuth-notoken',message:'No token found in localStorage',data:{pathname:location.pathname,localStorageKeys:Object.keys(localStorage)},timestamp:Date.now(),sessionId:'debug-session',runId:'session-debug',hypothesisId:'S2'})}).catch(()=>{});
          // #endregion agent log
          setIsAuthenticated(false);
          setIsLoading(false);
          console.log('No token found, not authenticated');
          return;
        }

        // #region agent log
        fetch('http://127.0.0.1:7243/ingest/c774ac2f-3ff0-4054-a0b4-90f182dc7495',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'ProtectedRoute.js:verifyAuth-beforeapi',message:'Token found, calling checkAuth API',data:{pathname:location.pathname,hasToken:true},timestamp:Date.now(),sessionId:'debug-session',runId:'session-debug',hypothesisId:'S3'})}).catch(()=>{});
        // #endregion agent log

        const response = await checkAuth();
        
        // #region agent log
        fetch('http://127.0.0.1:7243/ingest/c774ac2f-3ff0-4054-a0b4-90f182dc7495',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'ProtectedRoute.js:verifyAuth-afterapi',message:'checkAuth API response received',data:{success:response?.success,hasUser:!!response?.user,userRole:response?.user?.role,pathname:location.pathname},timestamp:Date.now(),sessionId:'debug-session',runId:'session-debug',hypothesisId:'S4'})}).catch(()=>{});
        // #endregion agent log
        
        console.log('Auth check response:', response);
        if (response.success) {
          setUser(response.user);
          setIsAuthenticated(true);
          console.log('Authenticated user:', response.user);
          // Check if trying to access admin route without admin role
          if (location.pathname.includes('/dashboard/admin') && response.user.role !== 'Admin') {
            console.log('Non-admin user trying to access admin route');
            setIsAuthenticated(false);
          }
        } else {
          // #region agent log
          fetch('http://127.0.0.1:7243/ingest/c774ac2f-3ff0-4054-a0b4-90f182dc7495',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'ProtectedRoute.js:verifyAuth-failed',message:'Auth verification failed',data:{responseSuccess:response?.success,pathname:location.pathname},timestamp:Date.now(),sessionId:'debug-session',runId:'session-debug',hypothesisId:'S5'})}).catch(()=>{});
          // #endregion agent log
          // If verification fails, clear the stored data
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          setIsAuthenticated(false);
          console.log('Auth verification failed');
        }
      } catch (error) {
        // #region agent log
        fetch('http://127.0.0.1:7243/ingest/c774ac2f-3ff0-4054-a0b4-90f182dc7495',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'ProtectedRoute.js:verifyAuth-error',message:'Auth verification error caught',data:{errorMessage:error?.message,errorStatus:error?.response?.status,pathname:location.pathname},timestamp:Date.now(),sessionId:'debug-session',runId:'session-debug',hypothesisId:'S6'})}).catch(()=>{});
        // #endregion agent log
        console.error('Auth verification error:', error);
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };

    verifyAuth();
  }, [location.pathname]);

  if (isLoading) {
    console.log('ProtectedRoute: loading...');
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    console.log('ProtectedRoute: not authenticated, redirecting to login');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  console.log('ProtectedRoute: authenticated, rendering children');
  return <Outlet context={{ user }} />;
};

export default ProtectedRoute;
